<template>
  <div class="flex flex-col gap-4 px-7 py-5">
    <p class="text-beige-50 text-sm">
      System prompt sent to Bedrock for the Design with AI feature. Changes take effect immediately
      without a deploy.
    </p>
    <v-textarea
      v-model="promptText"
      variant="outlined"
      density="compact"
      rows="16"
      hideDetails
      :disabled="saving"
      class="font-mono text-sm"
    />
    <div class="flex items-center gap-3">
      <v-btn color="primary" :loading="saving" :disabled="!promptText" @click="save">
        Save Prompt
      </v-btn>
      <span v-if="saveStatus === 'success'" class="text-sm text-green-600"
        >Saved successfully.</span
      >
      <span v-if="saveStatus === 'error'" class="text-sm text-red-600">Failed to save.</span>
    </div>
  </div>
</template>

<script setup>
import { onMounted, ref, watch } from "vue";
import ApiAiDesign from "@/apis/ApiAiDesign";

const promptText = ref("");
const saving = ref(false);
const saveStatus = ref(null);

// Clear the save status once the user edits again so a stale "Saved successfully."
// message doesn't imply the latest edits are saved.
watch(promptText, () => {
  saveStatus.value = null;
});

onMounted(async () => {
  try {
    const prompt = await ApiAiDesign.getDesignPrompt();
    // Don't clobber edits the user may have started before the fetch resolved.
    if (!promptText.value) {
      promptText.value = prompt.system_prompt ?? "";
    }
  } catch {
    // non-fatal — textarea stays empty
  }
});

async function save() {
  saving.value = true;
  saveStatus.value = null;
  try {
    await ApiAiDesign.updateDesignPrompt(promptText.value);
    saveStatus.value = "success";
  } catch {
    saveStatus.value = "error";
  } finally {
    saving.value = false;
  }
}
</script>
